import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const sleepAndRestGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-1',
    position: [90, 15],
    opacity: 0.3,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-2',
    position: [10, 0],
    opacity: 0.3,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-3',
    position: [55, 35],
    opacity: 0.3,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-4',
    position: [20, 65],
    opacity: 0.1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-5',
    position: [60, 84],
    opacity: 0.2,
    size: 20,
  },
];

export default sleepAndRestGradients;
